import React from 'react'

import { mergeStyles } from '@enlyt/helpers/mergeStyles'

import themeStyles from './styles'
import { useTheme } from 'contexts/ThemeProvider'
import { Image } from 'semantic-ui-react'
import AuthFooter from 'components/Auth/AuthFooter'
import Logo from 'components/Logo'

const HeroFamily = '/media/images/custom/images/login/eh-login@2x.png'

const AuthTemplate = props => {
  const { theme } = useTheme()
  const defaultStyles = themeStyles(theme)
  const styles = mergeStyles(defaultStyles, props.style)
  return (
    <div style={styles.container}>
      <div style={styles.verticalLogoContainer}>
        <Logo />
      </div>
      <div style={styles.imageContainer}>
        <Image
            alt={'CHOC'}
            src={HeroFamily}
            fluid
            style={styles.heroImage}
          />
      </div>
      <div style={{ ...styles.childContainer, ...styles.childContainerVertical }}>{props.children}</div>
      <AuthFooter style={styles.footer} />
    </div>
  )
}

export default AuthTemplate
